var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27344 5.95312H12.7266V0.5H7.27344V5.95312ZM14.5469 0.5V5.95312H20V0.5H14.5469ZM0 5.95312H5.45312V0.5H0V5.95312ZM7.27344 13.2266H12.7266V7.77344H7.27344V13.2266ZM14.5469 13.2266H20V7.77344H14.5469V13.2266ZM0 13.2266H5.45312V7.77344H0V13.2266ZM7.27344 20.5H12.7266V15.0469H7.27344V20.5ZM14.5469 20.5H20V15.0469H14.5469V20.5ZM0 20.5H5.45312V15.0469H0V20.5Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApps);
export default __webpack_public_path__ + "static/media/apps.1863a10a23dfe8411e8c0f62102b0c6f.svg";
export { ForwardRef as ReactComponent };